<template>
  <div :class="editing ? 'editingProduct' : 'viewingProduct'">
    <div v-for="category in product.categories"
         :key="category.name">
      <CategoryDisplay :category="category"
                       v-if="!category.locked || category.waitingForProcessing" />
    </div>
  </div>
</template>
<script>
import CategoryDisplay from './CategoryDisplay';

export default {
  name: 'ProductDisplay',
  components: {
    CategoryDisplay
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
<style lang="scss" scoped>
.editingProduct {
  min-height:1000px;
  max-height: 1000px;
  overflow-y:scroll;
}

.viewingProduct {
  min-height:1000px;
  max-height: 1000px;
  overflow-y:scroll;
}
</style>
